<template>
  <div v-if="partnerMetadata && partnerMetadata.ID" class="partnerInfo" :style="backgroundColor">
    <ik-image loading="lazy" :transformation="[{ height: 60, width: 60 }]" v-if="partnerMetadata && partnerMetadata.profileImageUrl" :src="partnerMetadata.profileImageUrl" class="picture" />
    <div v-else class="picture smallBorder">
      <IconBase icon-name="profile" iconColor="#222" viewBox="0 0 32 32" width="100%" height="100%" strokeWidth="0px"><IconProfileImg /></IconBase>
    </div>
    <div class="name">{{ partnerMetadata.displayName }}</div>
    <div class="sessionCount">{{ partnerSessionCount }} sessions</div>
    <RemoteVideoIndicators v-show="remoteParticipantData && !partnerDisconnected && !partnerLeft" :partnerAudio="partnerAudio" :partnerVideo="partnerVideo" :partnerScreen="partnerScreen" />
    <div class="brb" v-if="partnerState.brb.value && (!partnerState.brb.supportState || partnerState.brb.supportState == '')">brb</div>
    <div
      class="brb supportState"
      :class="partnerState.brb.supportState == 'dino' ? 'dino-color' : ''"
      v-else-if="partnerState.brb.value && partnerState.brb.supportState && partnerState.brb.supportState !== ''"
    >
      <span class="supportEmoji">{{ emojis[partnerState.brb.supportState] }}</span
      >brb
    </div>
  </div>
  <div v-else class="partnerInfo" :style="backgroundColor">
    <div class="name no-partner">No partner yet</div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import IconBase from "../../../../components/IconBase";
import IconProfileImg from "../../../../components/SVG/IconProfileImg";
import RemoteVideoIndicators from "./RemoteVideoIndicators";

import { backgroundColor } from "../SessionHelpers/colors";

export default {
  name: "PartnerInfo",
  components: {
    IconBase,
    IconProfileImg,
    RemoteVideoIndicators,
  },
  data() {
    return {
      emojis: {
        coffee: "☕",
        tea: "🍵",
        water: "🚰",
        restroom: "🚾",
        dino: "🦕",
        unicorn: "🦄",
        kitty: "🐈",
      },
    };
  },
  computed: {
    ...mapState({
      partnerMetadata: (state) => state.session.partnerMetadata,

      remoteParticipantData: (state) => state.room.remoteParticipantData,

      partnerSessionCount: (state) => state.remoteProfileData.partnerSessionCount,

      partnerAudio: (state) => state.room.partnerAudio,
      partnerVideo: (state) => state.room.partnerVideo,
      partnerScreen: (state) => state.room.partnerScreen,

      partnerState: (state) => state.mediastates.partnerState,

      partnerLeft: (state) => state.sessionState.partnerLeft,
      partnerDisconnected: (state) => state.sessionState.partnerDisconnected,
    }),
    getPartnerProfileLink() {
      if (this.partnerMetadata && this.partnerMetadata.ID) return `/profile/${this.partnerMetadata.ID}`;
      return "";
    },
    backgroundColor() {
      return backgroundColor();
    },
  },
};
</script>

<style>
@import "../SessionStyles/PartnerInfo.css";
</style>
